// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItem from "app/models/TimelineItem";

import "./NotSupportedCard.scss";

type Props = {
    item: TimelineItem
};

@observer
export default class NotSupportedCard extends React.Component<Props> {
    render() {
        const item = this.props.item;

        return (
            <div className="NotSupportedCard">
                {item.type} items are currently not supported
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCard/NotSupportedCard/NotSupportedCard.js